module.exports = __webpack_public_path__ + "img/4.f2488329.png";